import React from 'react';
import { TrendingUp, Target, BarChart4 } from 'lucide-react';

const rw = "https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/rw.svg";
const lsg = "https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/ls.svg";
const lens = "https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/lens.svg";

// Reusable icon row component
// Section mapping for use in WhyMaxiom.js
export const HERO2_SECTIONS = [
  { id: 'our-investment-philosophy', label: 'RootsWings', icon: rw, tooltip: 'Roots & Wings' },
  { id: 'threeEye', label: '3Lens', icon: lens, tooltip: 'Three Lens' },
  { id: 'lsg', label: 'LSG', icon: lsg, tooltip: 'LSG' },
];

export const Hero2IconsRow = ({ onIconClick, compact = false, activeSection }) => {
  // Tailwind classes for compact/normal mode
  const iconSize = compact ? "w-10 h-10" : "w-24 h-24";
  const textSize = compact ? "text-xs md:text-sm" : "text-lg md:text-xl";
  const padding = compact ? "p-0.5" : "p-2";
  const marginTop = compact ? "mt-0.5" : "mt-4";
  const rowGap = compact ? "gap-0.5 md:gap-1 mt-1 md:mt-2" : "gap-2 mt-8";
  const rowHeight = compact ? "h-22 md:h-22" : "";

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 ${rowGap} bg-white z-50 ${rowHeight} items-center`}>

      {HERO2_SECTIONS.map((section, idx) => (
        <div
          key={section.id}
          className={`flex flex-col items-center ${padding} rounded-lg cursor-pointer transition duration-200 relative group"
            ${activeSection === section.id ? 'bg-blue-50 shadow text-blue-700 scale-105' : 'hover:bg-gray-100 hover:shadow'}
          `}
          onClick={() => onIconClick && onIconClick(section.id)}
          tabIndex={0}
          title={section.tooltip}
          aria-label={section.tooltip}
        >
          <img src={section.icon} alt={section.label} className={`${iconSize} transition duration-200`} />
          <span className={`${textSize} mt-1 text-center transition duration-200 ${activeSection === section.id ? 'font-bold text-blue-700' : 'text-gray-500 group-hover:text-blue-500'}`}>{section.label}</span>
          {/* Tooltip on hover */}
          <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-gray-800 text-white text-xs rounded px-2 py-1 pointer-events-none z-50 whitespace-nowrap">
            {section.tooltip}
          </span>
        </div>
      ))}
    </div>
  );
}

const Hero2 = () => {
  return (
    <div>
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8 text-center">
        <h2 className="text-lg md:text-xl leading-relaxed text-center text-gray-800 font-semibold">
          Our systematic approach focuses on quality investments that stand the test of time.
        </h2>
        {/* Three icons in a row */}
        <Hero2IconsRow />
      </div>
    </div>
  );
};

export default Hero2;